import { atom } from "recoil";

const reminderAtom = atom({

    key:"reminderState",
    default: {}

});

export default reminderAtom;